export default __webpack_public_path__ + "static/media/bg_1.5cac91d9.jpg";